import './App.css';
import React, { useEffect, useState } from 'react';
import { Button, ConfigProvider, Layout, Select, } from 'antd';
import { setLanguage } from "./features/language/languageSlice";
import { language_state } from './features/language/languageSlice';
import { useDispatch, useSelector } from 'react-redux';
import i18n from "i18next";
import translationEN from "./language/en/common.json"
import translationES from "./language/es/common.json"
import SgvMapByIdComponent from './components/sgvmap/SgvMapByIdComponent';
import VicaHeader from './components/vica/VicaHeader';
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { MapService } from './service/mapService';
import AdministradorComponent from './components/administration/AdministradorComponent';
import { SecurityService } from './service/securityService';
import { login } from './features/user/userSlice';
import AdministradorComponentV2 from './components/administration/AdministradorComponentV2.';


const { Header, Footer, Sider, Content } = Layout;

const resources = {
    'en': {
        translation: translationEN
    },
    'es': {
        translation: translationES
    }
};

i18n
    /*.use(detector)*///TODO revisar. No funciona el detector
    /*.use(reactI18nextModule)*/ // passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: "es", // use en if detected lng is not available
        keySeparator: "."
    });

const App = () => {

    const dispatch = useDispatch();
    const languageState = useSelector(language_state);
    const [version, setVersion] = useState();
    const [loadApp, setLoadApp] = useState();


    //Recuperamos la app a la que entrar desde el parámetro app recibido
    const [searchParams, setSearchParams] = useSearchParams();
    let app = searchParams.get("app")
    let username = searchParams.get("username")
    let pw = searchParams.get("pw")


    useEffect(() => {
        //Si pasamos usuario y contraseña como parámetros, nos logueamos
        if (username && pw) {
            SecurityService.authenticate(username, pw).then((data) => {
                let token = data.token;
                let userFeature = {};
                userFeature.username = data.username
                userFeature.authorities = [];
                userFeature.token = token;
                dispatch(login(userFeature))
                SecurityService.getUser(token).then((data) => {
                    let userFeature = {};
                    userFeature.username = data.username
                    userFeature.authorities = data.roles;
                    userFeature.token = token;
                    dispatch(login(userFeature))
                    setLoadApp(true)

                })
            })
        }
        else {
            setLoadApp(true)
        }

    }, [])


    useEffect(() => {
        dispatch(setLanguage("es"))

        MapService.getVersion().then((data) => {
            setVersion(data.version)
        })
    }, [])

    const handleChangeLanguage = (value) => {
        dispatch(setLanguage(value))
    };

    const renderContent = () => {
        if (loadApp) {
            if (app == "administration") {
                return <AdministradorComponent />
            }
            if (app == "administrationV2") {
                return <AdministradorComponentV2 />
            }
            else {
                return <ConfigProvider locale={languageState.antd}>
                    <div>
                        <VicaHeader style={{}}></VicaHeader>
                        <SgvMapByIdComponent style={{}} mapId={0}></SgvMapByIdComponent>
                    </div>
                </ConfigProvider>
            }
        }
        else {
            return <></>
        }

    };

    return (
        <>
            {
                renderContent()
            }
            <div style={{ position: "absolute", right: "5px", bottom: "5px", zIndex: "10000" }}>v {version}</div>
        </>
    );
}

export default App;
